$(document).ready(function() {
	
	setup_ajax_addtocart();
	process_cookie();
	var $product_image_slideshow;
	product_image_carousel();

  
	function setup_ajax_addtocart() {
		var $formSelector = '#AddToCartForm--product-template';
		var $addToCartSelector = 'button[type="submit"]';
		var $formContainer = $($formSelector);
		var $addToCart = $formContainer.find($addToCartSelector);

		if($formContainer.length) {
			$formContainer.on('submit', function(evt) {
      			evt.preventDefault();

      			if($addToCart.hasClass('disabled') || $addToCart.hasClass('is-adding')) {
      				return;
      			}

				// Add class to be styled if desired
      			$addToCart.removeClass('is-added').addClass('is-adding');
      			ajax_addItemFromForm(evt.target);
      		});
		}
	}

	function ajax_addItemFromForm(form) {
		var $formSelector = '#AddToCartForm--product-template';
		var $addToCartSelector = 'button[type="submit"]';
		var $formContainer = $($formSelector);
		var $addToCart = $formContainer.find($addToCartSelector);
		var $addToCartNotification = $('#addedtocart--notification');

		var params = {
		    type: 'POST',
		    url: '/cart/add.js',
		    data: jQuery(form).serialize(),
		    dataType: 'json',
		    success: function(data) {
		    	$addToCart.removeClass('is-adding').addClass('is-added');
		    	$addToCartNotification.fadeIn().delay(1000).fadeOut();
		    	hellome_fetch_popup_cart();
              	setTimeout(function(){ window.location.href = '/cart';},1000);
		      	console.log(data);
		    },
		    error: function(XMLHttpRequest, textStatus) {
		      	console.log(XMLHttpRequest);
		      	console.log(textStatus);
		    }
  		};
  		$.ajax(params);
	}


	$(document).on('click','#homepage-instagram--feed .feed-item',function(){
		var $target_index = $(this).index() + 1;

		$('#homepage-instagram--overlay--content .overlay--feed-item').removeClass('active');
		$('#homepage-instagram--overlay--content .overlay--feed-item:nth-child(' + $target_index +')').addClass('active');

		$('#homepage-instagram--overlay').fadeIn();
		$('#homepage-instagram--overlay--content').fadeIn();
	});

	$(document).on('click','#homepage-instagram--overlay--content',function(){
		$('#homepage-instagram--overlay').fadeOut(function(){
			$('#homepage-instagram--overlay .overlay--feed-item').removeClass('active');
		});
		$('#homepage-instagram--overlay--content').fadeOut();
	});
  
  	

	$(document).on('change','.chkterms',function(e) {
    var btnCheckout = $('.btn-cart__checkout');

    if (this.checked) {
      btnCheckout.removeClass('deactivate');
    } else {
      btnCheckout.addClass('deactivate');
    }
  });

	$(document).on('click','.btn-cart__checkout',function(e){
		$chkterms_value = $('.chkterms').prop('checked');

		if($chkterms_value == false) {
			e.preventDefault();
      alert('Please accept terms and conditions!');
		} else {
			$('[name="checkout"]').click();
		}
	});
    
    

	$(document).on('mouseenter','#menu-item--cart',function(e){
		$('#cart--popup--wrapper').addClass('show');
	}).on('mouseleave','#menu-item--cart',function(e){
		var $goingto = e.relatedTarget || e.toElement;

		setTimeout(function(){

			if($goingto) {
				if($goingto.id != 'cart--popup--wrapper' && $goingto.id != 'cart--popup' && $goingto.id != 'cart--popup-contents') {
					$('#cart--popup--wrapper').removeClass('show');
				}
			}

		}, 300);

	});

	$(document).on('mouseleave','#cart--popup--wrapper',function(e){
		var $goingto = e.relatedTarget || e.toElement;

		if($goingto) {
			if($goingto.id != '#menu-item--cart') {
				$('#cart--popup--wrapper').removeClass('show');
			}
		}
	});

	$(document).on('click','.menu-trigger',function(e){
		$('#mobile-menu').fadeIn();
	});

	$(document).on('click','.mobile-menu-close',function(e){
		$('#mobile-menu').fadeOut();
	});

	$(document).on('click','.accordion-title',function(e){
		$(this).toggleClass('open');
		$(this).parent().find('.accordion-description').slideToggle();
	});

	$(document).on('click','.customerservice-tabs-title--section-item',function(e) {
		$('.customerservice-tabs-title--section-item').removeClass('active');
		$(this).addClass('active');
		var $target = $(this).data('target');

		$('.customerservice-tabs-content--section-item').removeClass('active');

		setTimeout(function(){
			$('.customerservice-tabs-content--section-item').addClass('moveaway');
			$('#' + $target).removeClass('moveaway').addClass('active');
		}, 400);
	});

	$(document).on('click','#product--additional-info--menu li',function(e) {
		$('#product--additional-info--menu li').removeClass('active');
		$(this).addClass('active');
		var $target = $(this).data('target');

		$('.product--additional-info--content-item').removeClass('active');

		setTimeout(function(){
			$('.product--additional-info--content-item').addClass('moveaway');
			$('#' + $target).removeClass('moveaway').addClass('active');
		}, 400);
	});


	$(document).on('click','#mobile-menu-item--shop',function(e){
		$('#mobile-shop-menu').fadeIn();
	});

	$(document).on('click','.mobile-shop-menu-back',function(e){
		$('#mobile-shop-menu').fadeOut();
	});

	$(document).on('click','#popup-close', function(){
	  $('#hellome--popup').fadeOut();
	});

	$(document).on('click','#footer-newsletter--trigger', function(){
	  $(this).find('.newsletter-label').addClass('hideit');
	  $(this).find('.hellome-newsletter-form').addClass('shown');
	});

	$('body').on('click','.product--image-slider--item', function(e){
		$product_image_slideshow.slick('slickNext');
	});

	$(window).on('resize',function(){
		//homepage_instagram_carousel();
		press_instagram_carousel();
	});

	$(window).on('scroll',function() {
	    var y = $(this).scrollTop();
	    var element = $('#site-header');

	    if(y > 50 && element.length && ! element.hasClass('scroll')) {
	      element.addClass('scroll');
	    }

	    if(y <= 50 && element.length) {
	      element.removeClass('scroll');
	    }
  	});

  	function process_cookie() {
	    if(Cookies.enabled && Cookies.get('hmpopup') != 1) {
	      Cookies.set('hmpopup', 1, { expires: 86400 } );
	      $('#hellome--popup').fadeIn();
	    } else {
	      $('#hellome--popup').fadeOut();
	    }
  	}

  	$('#hellome--intro-module').on("mousewheel DOMMouseScroll", function(e) {
		e.preventDefault();
	    if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {

	    } else {
	      	setup_stage();
	    }
  	});

  	$('body').on('click','#hellome--intro-module', function(e) {
		setup_stage();
	});

  	$('#hellome--intro-module').bind('touchmove', function(e) {
		e.preventDefault();
		setup_stage();
	});

	$(document).on('click','#homepage-hero--content-right-bottom a', function(e){
	    e.preventDefault();
	    slidetoproducts();
  	});

  	$(document).on('click','.yotpo-pager .yotpo-page-element',function(e){
  		setTimeout(function(){
  			var element = $('#shopify-section-product-reviews');
  			$('html, body').animate({ scrollTop: element.offset().top }, 1000);
  		}, 1000);
  	});

	var scrollingScreen = false;

	$('#thewomenbehind-hero').on("mousewheel DOMMouseScroll", function(e) {
		if(!scrollingScreen) {
			scrollingScreen = true;
			if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
	      		$('html, body').animate({ scrollTop: 0 }, $(window).scrollTop() * (1500 / 970), function() { scrollingScreen = false; } );
		    } else {
		    	$('html, body').animate({ scrollTop: $('#thewomenbehind-founders').offset().top }, 1500, function() { scrollingScreen = false; } );
		    }
		}
	    return false;
  	});

	function setup_stage() {
		$('#hellome--intro-module').addClass('push');
		$('#site-header').removeClass('push');
		$('#PageContainer').removeClass('push');

		setTimeout(function(){
			$('#site-container').removeClass('fixed');
			$('#hellome--intro-module').remove();
			$('.template-index #PageContainer').css('transform','none');
		}, 2000);
	}

	function product_image_carousel() {

		if($('#product--image-slider').length) {

			if(!$('#product--image-slider').hasClass('slick-initialized')) {

				$product_image_slideshow = $("#product--image-slider").slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: false,
			        dots: true,
			        fade: true,
			        customPaging : function(slider, i) {
					    var thumb = $(slider.$slides[i]).data();
					    return '<a class="dot">'+(i+1)+'</a>';
	            	},
			        infinite: true,
			        autoplay: false,

			        responsive: [
			          {
			          	breakpoint: 768,
			          	settings: {
			          		fade: false
			          	}
			          }
			        ]
			    });
			}
		}
	}


	function slidetoproducts(){
	  var element = $('#homepage-products');

	  $('html, body').animate({ scrollTop: element.offset().top }, 1000);
	}


});


$(window).on('load',function(){

	homepage_intro_animate();
	homepage_press_carousel_v2();
	homepage_press_carousel();
	press_carousel();
	press_instagram_carousel();
	about_tabs_slider();
	thewomenbehind_experts_carousel();
	homepage_instagram('hellome.co');
	hellome_fetch_popup_cart();
	stick_faqs_image();
	stick_customer_service_content();
	stick_product_slider();
	// $('.preloader').fadeOut('slow');
});



function homepage_intro_animate() {
	if($('#hellome--intro-module').length) {

		var $starting_index = 0;

		setInterval(function(){

			var $grid_item = $('#hellome--intro-module').find('.hellome--intro-module-column:eq(' + $starting_index + ')').find('.image-container:visible');

			var $current_active = $grid_item.find('img.active');
			$next_element = $current_active.next('img');

			if($next_element.length == 0) {
				$next_element = $grid_item.find('img').first();
			}

			$grid_item.find('img').removeClass('active');
			$next_element.addClass('active');
			$starting_index++;

			if($starting_index == 3) {
				$starting_index = 0;
			}

		},750);

	}
}


function homepage_instagram_carousel() {
	if($('#homepage-instagram--feed .feed-item').length) {
		if(!$('#homepage-instagram--feed').hasClass('slick-initialized') && $(window).width() < 992) {

			$("#homepage-instagram--feed").slick({
		        slidesToShow: 1.1,
		        slidesToScroll: 1,
		        mobileFirst: true,
		        arrows: false,
		        dots: false,
		        infinite: false,
		        autoplay: false,

		        responsive: [
		          {
		          	breakpoint: 500,
		          	settings: {
		          		slidesToShow: 2.5,
			        	slidesToScroll: 1,
			        	centerMode: false
		          	}
		          },
		          {
		          	breakpoint: 991,
		          	settings: 'unslick'
		          }
		        ]
		    });
		}
	}
}


function about_tabs_slider() {



	if($('#about-tabs-content--slider').length) {
		if(!$('#about-tabs-content--slider').hasClass('slick-initialized')) {

			$("#about-tabs-content--slider").slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        arrows: false,
		        dots: false,
		        infinite: true,
		        autoplay: false,
		        fade: true,
		        swipe: false
		    });
		}
	}

	if($('#about-tabs-title--slider').length) {
		if(!$('#about-tabs-title--slider').hasClass('slick-initialized')) {

			$("#about-tabs-title--slider").slick({
		        slidesToShow: 3,
		        slidesToScroll: 1,
		        arrows: false,
		        dots: false,
		        infinite: false,
		        autoplay: false,
		        vertical: true,
		        asNavFor: '#about-tabs-content--slider',
		        focusOnSelect: true,

		        responsive: [
		          {
		          	breakpoint: 768,
		          	settings: {
		          		slidesToShow: 1,
			        	slidesToScroll: 1,
			        	arrows: true,
			        	vertical: false,
			        	fade: true,
			        	infinite: true,
			        	prevArrow: "<img class='slick-prev slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-prev.svg?v=2845204569308045381613688485\">",
		        		nextArrow: "<img class='slick-next slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-next.svg?v=20175131423990605151613688484\">"
		          	}
		          }
		        ]
		    });
		}
	}

}


function press_carousel() {

	if($('#press-text--slider').length) {
		if(!$('#press-text--slider').hasClass('slick-initialized')) {

			$("#press-text--slider").slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        arrows: true,
		        dots: false,
		        infinite: true,
		        autoplay: false,
		        fade: true,
		        prevArrow: "<img class='slick-prev slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-prev.svg?v=2845204569308045381613688485\">",
		        nextArrow: "<img class='slick-next slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-next.svg?v=20175131423990605151613688484\">"
		    });
		}
	}


	if($('#press-logo--slider').length) {
		if(!$('#press-logo--slider').hasClass('slick-initialized')) {

			$("#press-logo--slider").slick({
		        slidesToShow: 3,
		        slidesToScroll: 1,
		        arrows: false,
		        dots: false,
		        infinite: true,
		        autoplay: false,
		        centerMode: true,
		        centerPadding: '0px',
		        variableWidth: true,
		        asNavFor: '#press-text--slider',
		        focusOnSelect: true,

		        responsive: [
		          {
		            breakpoint: 768,
		            settings: {
		            	slidesToShow: 1,
		        		slidesToScroll: 1,
		        		variableWidth: false
		            }
		          }
		        ]
		    });
		}
	}

	$('#press-text--slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	 	var mySlideNumber = nextSlide;

	 	$('#press-logo--slider .slick-slide').removeClass('slick-current');
	 	$('#press-logo--slider .slick-slide[data-slick-index=' + mySlideNumber + ']').addClass('slick-current');
	 	$('#press-logo--slider').slick('slickGoTo',mySlideNumber);
	});

}

function press_instagram_carousel() {
	if($('#press-instagram--posts').length) {
		if(!$('#press-instagram--posts').hasClass('slick-initialized') && $(window).width() < 992) {

			$("#press-instagram--posts").slick({
		        slidesToShow: 1.2,
		        slidesToScroll: 1,
		        mobileFirst: true,
		        arrows: false,
		        dots: false,
		        infinite: false,
		        autoplay: false,

		        responsive: [
		          {
		          	breakpoint: 500,
		          	settings: {
		          		slidesToShow: 2.5,
			        	slidesToScroll: 1,
			        	centerMode: false
		          	}
		          },
		          {
		          	breakpoint: 991,
		          	settings: 'unslick'
		          }
		        ]
		    });
		}
	}
}

function homepage_press_carousel_v2() {
	if($('#homepage-press--slider-v2').length) {
		if(!$('#homepage-press--slider-v2').hasClass('slick-initialized')) {
			$("#homepage-press--slider-v2").slick({
				slidesToShow: 1,
		    slidesToScroll: 1,
				fade: true,
				arrows: true
			});
		}
	}
}

function homepage_press_carousel() {

	if($('#homepage-press--slider').length) {

		if(!$('#homepage-press--slider').hasClass('slick-initialized')) {

			$("#homepage-press--slider").slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        arrows: false,
		        dots: true,
		        fade: true,
		        customPaging : function(slider, i) {
				    var thumb = $(slider.$slides[i]).data();
				    return '<a class="dot">'+(i+1)+'</a>';
            	},
		        infinite: false,
		        autoplay: false
		    });
		}
	}
}


function thewomenbehind_experts_carousel() {

	if($('#thewomenbehind-experts--slider').length) {

		if(!$('#thewomenbehind-experts--slider').hasClass('slick-initialized')) {

			$("#thewomenbehind-experts--slider").slick({
		        slidesToShow: 4,
		        slidesToScroll: 1,
		        arrows: false,
		        dots: false,
		        infinite: true,
		        autoplay: false,
		        centerMode: true,
		        centerPadding: '75px',

		        responsive: [
		          {
		          	breakpoint: 1440,
		          	settings: {
		          		slidesToShow: 3,
			        	slidesToScroll: 1,
		          	}
		          },
		          {
		          	breakpoint: 992,
		          	settings: {
		          		slidesToShow: 2,
			        	slidesToScroll: 1,
		          	}
		          },
		          {
		          	breakpoint: 768,
		          	settings: {
		          		slidesToShow: 1,
			        	slidesToScroll: 1,
			        	centerMode: false,
			        	arrows: true,
			        	prevArrow: "<img class='slick-prev slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-prev-black.svg?v=168164133116778740731613688485\">",
		        		nextArrow: "<img class='slick-next slick-arrow' src=\"//cdn.shopify.com/s/files/1/0058/6891/2740/t/22/assets/slick-next-black.svg?v=89514818165992490981613688483\">"
		          	}
		          }
		        ]
		    });
		}
	}
}


function homepage_instagram($insta_username) {

  if(Cookies.enabled && Cookies.get('instafeedhellome') == undefined) {

    $.instagramFeed({
      'username': $insta_username,
      'container': "#homepage-instagram--feed",
      'items': 6,
      'items_per_row': 6,
      'display_profile': false,
      'get_data':true,
      'callback':function(data){

        if(data.edge_owner_to_timeline_media.count > 0) {

          var imgs = (data.edge_owner_to_timeline_media || data.edge_hashtag_to_media).edges;
          max = 6;
          var html = "";
          var overlay_html = "";
          var image_index = 4; // For Size 640

          html += "<div class='gallery'>";

          for(var i = 0; i < max; i++){
              var url = "https://www.instagram.com/p/" + imgs[i].node.shortcode,
                  image, type_resource;

              switch(imgs[i].node.__typename){
                  case "GraphSidecar":
                      type_resource = "sidecar"
                      image = imgs[i].node.thumbnail_resources[image_index].src;
                      break;
                  case "GraphVideo":
                      type_resource = "video";
                      image = imgs[i].node.thumbnail_src
                      break;
                  default:
                      type_resource = "image";
                      image = imgs[i].node.thumbnail_resources[image_index].src;
              }

              html += "  <div class='feed-item feed-item--" + (i + 1) + "'>";
              html += "     <img src='" + image + "' alt='Hello.Me' />";
              html += "  </div>";

              overlay_html +=		"<div class='overlay--feed-item'>";
              overlay_html +=     "<a href='" + url +"' target='_blank'>";
              overlay_html +=     "<img src='" + image + "' alt='Hello.me'" +" />";
              overlay_html +=     "</a>";
              overlay_html +=		"<div class='overlay--feed-item-info'><div class='info--left'>@" + $insta_username + "</div><div class='info--right'>";
              overlay_html +=     "<a href='" + url + "' target='_blank'>";
              overlay_html +=		"Open Instagram</a></div></div>";
              overlay_html +=		"</div>";
          }

          html += "</div>";

          $('#homepage-instagram--feed').html(html);
          $('#homepage-instagram--overlay--content').html(overlay_html);

          Cookies.set('instafeedhellome', html);
          Cookies.set('instafeedochellome', overlay_html);

        } else {
          $('#homepage-instagram--feed').html('<p style="text-align:center">There are no posts available on instagram for this username: <span style="color:#ff5100">' + $insta_username + '</span></p>');
        }
      }
    });
  } else {
    html = Cookies.get('instafeedhellome');
    overlay_html = Cookies.get('instafeedochellome');

    $('#homepage-instagram--feed').html(html);
    $('#homepage-instagram--overlay--content').html(overlay_html);
  }

  //setTimeout(function(){ homepage_instagram_carousel(); }, 1000);
}






function hellome_fetch_cart() {
  $('#hellome--cart-contents').empty();
  $cart_html = '';

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {

      $cart_count = data.item_count;

      if($cart_count > 0) {
        $cart_items_count = data.items.length;
        $total_price = parseFloat(data.total_price / 100).toFixed(2);
        // $total_price = parseInt(data.total_price / 100);
        $json_cart_items = data.items;
        $json_cart_items_string = JSON.stringify(data);

        for ( i=0; i<$cart_items_count; i++ ) {

          $item_image_src = $json_cart_items[i].image;

          $item_price = parseFloat($json_cart_items[i].final_line_price / 100).toFixed(2);
          // $item_price = parseInt($json_cart_items[i].final_line_price / 100);

          $product_url = $json_cart_items[i].url;

          // Change Product URL for subscription Products

          if($json_cart_items[i].properties != null && $json_cart_items[i].properties.subscription_id) {
            $product_url = $product_url.replace("-1","");
          }

          $cart_html += '<div class="cart-item--row"><div class="cart-item--row-product--image">';

          if($item_image_src) {
            
            $cart_html += '<a href="' + $product_url + '"><img src="' + $item_image_src + '" alt="' + $json_cart_items[i].title + '"></a>';
          }
			
          
          $cart_html += '</div> \
            <div class="cart-item--row-product--info"> \
              <div class="cart-item--row-product--info-top"> \
                <div class="info-top--container"> \
                  <div class="cart-item--row-product--info-top--left"> \
                    <a href="' + $product_url + '" class="cart-product--title black">' + $json_cart_items[i].title + '</a> \
                    <!--<span class="subscription-text">Monthly Subscription</span>--> \
                  </div> \
                  \
                  <div class="cart-item--row-product--info-top--right"><a href="javascript:;" class="smaller black underline" onclick="removeCartItem(' + (i+1) + ')">Remove</a></div> \
                </div> \
                \
                <div class="info-top--container"> \
                  <label class="visually-hidden">Quantity</label> \
                  <div class="qtybox"> \
                    <span class="btnqty qtyminus" onclick="updateCartQty(' + (i+1) + ',' + $json_cart_items[i].quantity + ',\'minus\')">–</span> \
                    <input type="text" id="quantity" name="quantity" value="' + $json_cart_items[i].quantity + '" min="1" class="quantity-selector quantity-input" readonly=""> \
                    <span class="btnqty qtyplus" onclick="updateCartQty(' + (i+1) + ',' + $json_cart_items[i].quantity + ',\'plus\')">+</span> \
                  </div> \
                  <div class="cart-item--row-product--price"> \
                    <span>$' + $item_price + '</span> \
                  </div> \
                </div> \
              </div> \
              \
              <div class="cart-item--row-product--info-bottom"> \
                <p class="subtotal">Subtotal $' + $total_price + '</p> \
                <a href="#" class="btn-cart__checkout btn-primary deactivate">Check out</a> \
                <div class="accept-terms-box"> \
                  <p class="terms smaller"><input type="checkbox" class="chkterms">I agree to the <a href="https://hello.me/pages/terms-and-conditions" class="black underline">Terms and Conditions</a></p> \
                </div> \
              </div> \
            </div> \
          </div>';
        }

      } else {
        $('.empty-cart-content').addClass('active');
      }

      // $('#hellome--cart-contents').append($json_cart_items_string);
      $('#hellome--cart-contents').append($cart_html);
    },
    error: function(data) {
      alert('there is error');
      console.log(data);
    }
  });

  $('#hellome--cart-processing--overlay').fadeOut();
}


function hellome_fetch_popup_cart() {
	$('#cart--popup-contents').empty();
	$cart_popup_html = '';
	$cart_count = 0;

	$.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		success: function(data) {
			console.log(JSON.stringify(data.items));
			$cart_count = data.item_count;

			if($cart_count > 0) {
				$cart_items_count = data.items.length;
				$json_cart_items = data.items;

				for ( i=0; i<$cart_items_count; i++ ) {

					$item_image_src = $json_cart_items[i].image;
					$price_subscription_string = '';

					$product_url = $json_cart_items[i].url;
					$product_id = $json_cart_items[i].product_id;


					// Change Product URL for subscription Products

					if($json_cart_items[i].properties != null && $json_cart_items[i].properties.subscription_id) {
						$product_url = $product_url.replace("-1","");
						$price_subscription_string = '/2mo';
					}

					if($item_image_src) {
						$item_image_src = $item_image_src.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
					}

					$item_price = parseFloat($json_cart_items[i].final_price / 100).toFixed(2);
					// $item_price = parseInt($json_cart_items[i].final_price / 100);


					$cart_popup_html +=	'<div class="popup-cart-item--row"> \
						 	  		\
						 	  		\
						 	  		<div class="popup-cart-item--row-product--info"> \
	            						<a href="' + $product_url + '" class="cart-product--title black">' + $json_cart_items[i].title + '</a>';


            						if($json_cart_items[i].properties != null && $json_cart_items[i].properties.subscription_id) {

            						}

					$cart_popup_html += '<span class="popup-cart--item-price">$' + $item_price + $price_subscription_string + ' x ' + $json_cart_items[i].quantity + '</span><a href="javascript:;" class="black underline" onclick="removeCartItem(' + (i+1) + ')">Remove</a> \
									</div> \
									\
									\
						 	  		<div class="popup-cart-item--row-product--image">';

					if($item_image_src) {
						$cart_popup_html += '<a href="/collections/all' + $json_cart_items[i].url + '"><img src="' + $item_image_src + '" alt="' + $json_cart_items[i].title + '"></a>';
					}

	            	$cart_popup_html += '</div></div>';
				}

			} else {
				$cart_popup_html +=	'<p class="center">Your bag is currently empty.</p>';
			}

			$('.cart-count').html($cart_count);
			$('#cart--popup-contents').append($cart_popup_html);

			if($cart_count == 0) {
				$('.btn-cartpopup--checkout').fadeOut();
			} else {
				$('.btn-cartpopup--checkout').fadeIn();
			}
		},
		error: function(data) {
			alert('there is error');
			console.log(data);
		}
	});

	$('#cart--popup-processing--overlay').fadeOut();
}


function removeCartItem($line_item) {
	$('#hellome--cart-processing--overlay').fadeIn('fast');
	$('#cart--popup-processing--overlay').fadeIn('fast');

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		dataType: 'json',
		data: { quantity: 0, line: $line_item },
		success: function(data) {
			setTimeout(function(){
				hellome_fetch_cart();
				hellome_fetch_popup_cart();
			},500);
		}
	});
}

function updateCartQty($line_item,$current_qty,$action) {
	$('#hellome--cart-processing--overlay').fadeIn('fast');
	$('#cart--popup-processing--overlay').fadeIn('fast');

	if($action == 'plus') {
		$current_qty = $current_qty + 1;
	} else {
		$current_qty = $current_qty - 1;
	}

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		dataType: 'json',
		data: { quantity: $current_qty, line: $line_item },
		success: function(data) {
			setTimeout(function(){
				hellome_fetch_cart();
				hellome_fetch_popup_cart();
			},500);
		}
	});
}


function checkterms(event) {
	event.preventDefault();
	$chkterms_value = $('.chkterms').prop('checked');

	if($chkterms_value == false) {
		alert('Please accept terms and conditions!');
		return false;
	}
}


function stick_faqs_image() {
	var element = $('#faqs-questions--content-right .image-container');

	if(element.length) {
		if($(window).width() > 768) {
			element.stick_in_parent({
				parent: '#faqs-questions--content',
				offset_top: 6,
				recalc_every: 1
			});
		} else {
			element.trigger("sticky_kit:detach");
		}
	}
}

function stick_customer_service_content() {
	var element = $('#customerservice-tabs--content-left--wrapper');

	if(element.length) {
		element.stick_in_parent({
			parent: '#customerservice-tabs--content',
			offset_top: 0,
			recalc_every: 1
		});
	}
}

function stick_product_slider() {
	var element = $('#product-intro--content-left--wrapper');

	if(element.length) {
		if($(window).width() > 768) {
			element.stick_in_parent({
				parent: '#product-intro--content',
				offset_top: 0,
				recalc_every: 1
			});
		} else {
			element.trigger("sticky_kit:detach");
		}
	}
}
